"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerApi = exports.PartnerApiFactory = exports.PartnerApiFp = exports.PartnerApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * PartnerApi - axios parameter creator
 */
const PartnerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Triggers bulk sponsorship churn when partner relationships end. Queries active users for the specified partner and publishes churn events to the notification service.  Sponsorship status updates, if any, are handled asynchronously by downstream consumers of these churn events; this endpoint itself does not directly modify user sponsorship status.  For now this endpoint is intended to be used by admins to notify Iterable of sponsorship churn, but in the future it can be extended to support internal use cases.  **Admin Access Required**: This endpoint requires admin write permissions.
         * @summary Trigger bulk sponsorship churn for partner
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminChurnSponsorships: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('adminChurnSponsorships', 'partnerId', partnerId);
            const localVarPath = `/v1/circles/admin/partners/{partner_id}/sponsorship/churn`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/admin/partners/{partner_id}/sponsorship/churn`,
                sdkMethod: 'adminChurnSponsorships',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns Partners config by partner id
         * @param {string} uniqCode Partner Unique Code
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandingPartnerConfig: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ uniqCode, acceptLanguage }, options = {}) {
            // verify required parameter 'uniqCode' is not null or undefined
            (0, common_1.assertParamExists)('getBrandingPartnerConfig', 'uniqCode', uniqCode);
            const localVarPath = `/v1/partners/codes/{uniq_code}/config`.replace('{uniq_code}', encodeURIComponent(String(uniqCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/codes/{uniq_code}/config`,
                sdkMethod: 'getBrandingPartnerConfig',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get unsponsored config
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleUnsponsoredConfig: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ acceptLanguage }, options = {}) {
            const localVarPath = `/v1/circles/configs/unsponsored`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/configs/unsponsored`,
                sdkMethod: 'getCircleUnsponsoredConfig',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns Partner Dependent Group config by partner id and dependent group ID
         * @param {string} partnerId The ID of the partner
         * @param {string} countryCode The country code of the dependent group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDependentGroupConfigByCountryCode: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, countryCode, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('getPartnerDependentGroupConfigByCountryCode', 'partnerId', partnerId);
            // verify required parameter 'countryCode' is not null or undefined
            (0, common_1.assertParamExists)('getPartnerDependentGroupConfigByCountryCode', 'countryCode', countryCode);
            const localVarPath = `/v1/partners/{partner_id}/dependent-groups/countries/{country_code}/config`
                .replace('{partner_id}', encodeURIComponent(String(partnerId)))
                .replace('{country_code}', encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/dependent-groups/countries/{country_code}/config`,
                sdkMethod: 'getPartnerDependentGroupConfigByCountryCode',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - | This endpoint will return the partner member for the given partner id and search criteria. This endpoint is only accessible to admin users. Note that every partner has a different set of search criteria.  Search criteria can be by: - validation fields like partnerId + (email, firstName, lastName, dob, subscriberId). - partner specific fields like partnerId + (memberId).
         * @summary Gets Partners Member as admin by partner id and search criteria.
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerMemberAsAdmin: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, memberId, email, firstName, lastName, dob, subscriberId, partnerMemberId, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('getPartnerMemberAsAdmin', 'partnerId', partnerId);
            const localVarPath = `/v1/partners/{partner_id}/members/search`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (firstName !== undefined) {
                localVarQueryParameter['first_name'] = firstName;
            }
            if (lastName !== undefined) {
                localVarQueryParameter['last_name'] = lastName;
            }
            if (dob !== undefined) {
                localVarQueryParameter['dob'] =
                    dob instanceof Date
                        ? dob.toISOString().substring(0, 10)
                        : dob;
            }
            if (subscriberId !== undefined) {
                localVarQueryParameter['subscriber_id'] = subscriberId;
            }
            if (partnerMemberId !== undefined) {
                localVarQueryParameter['partner_member_id'] = partnerMemberId;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/members/search`,
                sdkMethod: 'getPartnerMemberAsAdmin',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns Partners config by partner id
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigById: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('getPartnersConfigById', 'partnerId', partnerId);
            const localVarPath = `/v1/partners/{partner_id}/config`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/config`,
                sdkMethod: 'getPartnersConfigById',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return the partner config for the given uniq code. This endpoint is only accessible to admin users. After you got the partner config, you can use the partner_id to call the other endpoints. E.g. [/v1/partners/{partner_id}/members/search](https://apidoc.evexiaapp.site/#/circle/getPartnerMemberAsAdmin) to find member.
         * @summary Returns Partners config as admin by uniq code
         * @param {string} uniqCode Partner Unique Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigByUniqCodeAsAdmin: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ uniqCode }, options = {}) {
            // verify required parameter 'uniqCode' is not null or undefined
            (0, common_1.assertParamExists)('getPartnersConfigByUniqCodeAsAdmin', 'uniqCode', uniqCode);
            const localVarPath = `/v1/partners/codes/{uniq_code}`.replace('{uniq_code}', encodeURIComponent(String(uniqCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/codes/{uniq_code}`,
                sdkMethod: 'getPartnersConfigByUniqCodeAsAdmin',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Partner Child User Counts returns the number of distinct active users per child partner for a given parent partner. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner Child User Counts (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerChildUserCounts: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPartnerChildUserCounts', 'partnerId', partnerId);
            const localVarPath = `/v1/partners/{partner_id}/children/users/count`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/children/users/count`,
                sdkMethod: 'v1GetPartnerChildUserCounts',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Partner User Count returns the number of distinct users for a partner within a date range. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner User Count (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
         * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerUserCount: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, startDate, endDate }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPartnerUserCount', 'partnerId', partnerId);
            // verify required parameter 'startDate' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPartnerUserCount', 'startDate', startDate);
            // verify required parameter 'endDate' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPartnerUserCount', 'endDate', endDate);
            const localVarPath = `/v1/partners/{partner_id}/users/count`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] =
                    startDate instanceof Date
                        ? startDate.toISOString()
                        : startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] =
                    endDate instanceof Date
                        ? endDate.toISOString()
                        : endDate;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/users/count`,
                sdkMethod: 'v1GetPartnerUserCount',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Partner Users returns a paginated list of user accounts for a partner whose sponsorship_start_date falls within the given date range. Accounts are hydrated from the identity service. This endpoint is for internal admin use only.  Results are ordered by sponsorship `created_at DESC, user_id ASC` when `is_suspicious` is omitted (pagination driven by circle). When `is_suspicious` is supplied, the filter, pagination, and ordering are applied by identity over the full partner+date user_id set; ordering in that case is by account `created_at DESC, user_id ASC`.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner Users (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
         * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
         * @param {boolean} [isSuspicious] Optional filter on the &#x60;is_suspicious&#x60; flag. Omit to skip the filter; pass &#x60;true&#x60; to return only suspicious users; pass &#x60;false&#x60; to return only non-suspicious users.
         * @param {number} [limit] Max accounts to return per page. Defaults to 50, capped at 200.
         * @param {number} [offset] Number of accounts to skip. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerUsers: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, startDate, endDate, isSuspicious, limit, offset, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPartnerUsers', 'partnerId', partnerId);
            // verify required parameter 'startDate' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPartnerUsers', 'startDate', startDate);
            // verify required parameter 'endDate' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPartnerUsers', 'endDate', endDate);
            const localVarPath = `/v1/partners/{partner_id}/users`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] =
                    startDate instanceof Date
                        ? startDate.toISOString()
                        : startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] =
                    endDate instanceof Date
                        ? endDate.toISOString()
                        : endDate;
            }
            if (isSuspicious !== undefined) {
                localVarQueryParameter['is_suspicious'] = isSuspicious;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/users`,
                sdkMethod: 'v1GetPartnerUsers',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Mark Partner Users Suspicious marks users for a partner whose sponsorship was created within a date range as suspicious or not suspicious. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin write permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Mark Partner Users Suspicious (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {CircleMarkPartnerUsersSuspiciousRequest} circleMarkPartnerUsersSuspiciousRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MarkPartnerUsersSuspicious: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, circleMarkPartnerUsersSuspiciousRequest, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1MarkPartnerUsersSuspicious', 'partnerId', partnerId);
            // verify required parameter 'circleMarkPartnerUsersSuspiciousRequest' is not null or undefined
            (0, common_1.assertParamExists)('v1MarkPartnerUsersSuspicious', 'circleMarkPartnerUsersSuspiciousRequest', circleMarkPartnerUsersSuspiciousRequest);
            const localVarPath = `/v1/partners/{partner_id}/users/suspicious`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/users/suspicious`,
                sdkMethod: 'v1MarkPartnerUsersSuspicious',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(circleMarkPartnerUsersSuspiciousRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PartnerApiAxiosParamCreator = PartnerApiAxiosParamCreator;
/**
 * PartnerApi - functional programming interface
 */
const PartnerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PartnerApiAxiosParamCreator)(configuration);
    return {
        /**
         * Triggers bulk sponsorship churn when partner relationships end. Queries active users for the specified partner and publishes churn events to the notification service.  Sponsorship status updates, if any, are handled asynchronously by downstream consumers of these churn events; this endpoint itself does not directly modify user sponsorship status.  For now this endpoint is intended to be used by admins to notify Iterable of sponsorship churn, but in the future it can be extended to support internal use cases.  **Admin Access Required**: This endpoint requires admin write permissions.
         * @summary Trigger bulk sponsorship churn for partner
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminChurnSponsorships(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminChurnSponsorships(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PartnerApi.adminChurnSponsorships']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns Partners config by partner id
         * @param {string} uniqCode Partner Unique Code
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandingPartnerConfig(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBrandingPartnerConfig(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PartnerApi.getBrandingPartnerConfig']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get unsponsored config
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleUnsponsoredConfig(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCircleUnsponsoredConfig(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PartnerApi.getCircleUnsponsoredConfig']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Returns Partner Dependent Group config by partner id and dependent group ID
         * @param {string} partnerId The ID of the partner
         * @param {string} countryCode The country code of the dependent group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDependentGroupConfigByCountryCode(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnerDependentGroupConfigByCountryCode(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PartnerApi.getPartnerDependentGroupConfigByCountryCode']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - | This endpoint will return the partner member for the given partner id and search criteria. This endpoint is only accessible to admin users. Note that every partner has a different set of search criteria.  Search criteria can be by: - validation fields like partnerId + (email, firstName, lastName, dob, subscriberId). - partner specific fields like partnerId + (memberId).
         * @summary Gets Partners Member as admin by partner id and search criteria.
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerMemberAsAdmin(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnerMemberAsAdmin(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PartnerApi.getPartnerMemberAsAdmin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Returns Partners config by partner id
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigById(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnersConfigById(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PartnerApi.getPartnersConfigById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return the partner config for the given uniq code. This endpoint is only accessible to admin users. After you got the partner config, you can use the partner_id to call the other endpoints. E.g. [/v1/partners/{partner_id}/members/search](https://apidoc.evexiaapp.site/#/circle/getPartnerMemberAsAdmin) to find member.
         * @summary Returns Partners config as admin by uniq code
         * @param {string} uniqCode Partner Unique Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigByUniqCodeAsAdmin(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnersConfigByUniqCodeAsAdmin(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PartnerApi.getPartnersConfigByUniqCodeAsAdmin']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Get Partner Child User Counts returns the number of distinct active users per child partner for a given parent partner. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner Child User Counts (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerChildUserCounts(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetPartnerChildUserCounts(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PartnerApi.v1GetPartnerChildUserCounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Get Partner User Count returns the number of distinct users for a partner within a date range. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner User Count (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
         * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerUserCount(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetPartnerUserCount(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PartnerApi.v1GetPartnerUserCount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Get Partner Users returns a paginated list of user accounts for a partner whose sponsorship_start_date falls within the given date range. Accounts are hydrated from the identity service. This endpoint is for internal admin use only.  Results are ordered by sponsorship `created_at DESC, user_id ASC` when `is_suspicious` is omitted (pagination driven by circle). When `is_suspicious` is supplied, the filter, pagination, and ordering are applied by identity over the full partner+date user_id set; ordering in that case is by account `created_at DESC, user_id ASC`.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner Users (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
         * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
         * @param {boolean} [isSuspicious] Optional filter on the &#x60;is_suspicious&#x60; flag. Omit to skip the filter; pass &#x60;true&#x60; to return only suspicious users; pass &#x60;false&#x60; to return only non-suspicious users.
         * @param {number} [limit] Max accounts to return per page. Defaults to 50, capped at 200.
         * @param {number} [offset] Number of accounts to skip. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerUsers(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetPartnerUsers(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PartnerApi.v1GetPartnerUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Mark Partner Users Suspicious marks users for a partner whose sponsorship was created within a date range as suspicious or not suspicious. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin write permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Mark Partner Users Suspicious (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {CircleMarkPartnerUsersSuspiciousRequest} circleMarkPartnerUsersSuspiciousRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MarkPartnerUsersSuspicious(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MarkPartnerUsersSuspicious(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PartnerApi.v1MarkPartnerUsersSuspicious']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.PartnerApiFp = PartnerApiFp;
/**
 * PartnerApi - factory interface
 */
const PartnerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PartnerApiFp)(configuration);
    return {
        /**
         * Triggers bulk sponsorship churn when partner relationships end. Queries active users for the specified partner and publishes churn events to the notification service.  Sponsorship status updates, if any, are handled asynchronously by downstream consumers of these churn events; this endpoint itself does not directly modify user sponsorship status.  For now this endpoint is intended to be used by admins to notify Iterable of sponsorship churn, but in the future it can be extended to support internal use cases.  **Admin Access Required**: This endpoint requires admin write permissions.
         * @summary Trigger bulk sponsorship churn for partner
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminChurnSponsorships(params, options) {
            return localVarFp
                .adminChurnSponsorships(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns Partners config by partner id
         * @param {string} uniqCode Partner Unique Code
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandingPartnerConfig(params, options) {
            return localVarFp
                .getBrandingPartnerConfig(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get unsponsored config
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCircleUnsponsoredConfig(params, options) {
            return localVarFp
                .getCircleUnsponsoredConfig(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns Partner Dependent Group config by partner id and dependent group ID
         * @param {string} partnerId The ID of the partner
         * @param {string} countryCode The country code of the dependent group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDependentGroupConfigByCountryCode(params, options) {
            return localVarFp
                .getPartnerDependentGroupConfigByCountryCode(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - | This endpoint will return the partner member for the given partner id and search criteria. This endpoint is only accessible to admin users. Note that every partner has a different set of search criteria.  Search criteria can be by: - validation fields like partnerId + (email, firstName, lastName, dob, subscriberId). - partner specific fields like partnerId + (memberId).
         * @summary Gets Partners Member as admin by partner id and search criteria.
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerMemberAsAdmin(params, options) {
            return localVarFp
                .getPartnerMemberAsAdmin(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns Partners config by partner id
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigById(params, options) {
            return localVarFp
                .getPartnersConfigById(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return the partner config for the given uniq code. This endpoint is only accessible to admin users. After you got the partner config, you can use the partner_id to call the other endpoints. E.g. [/v1/partners/{partner_id}/members/search](https://apidoc.evexiaapp.site/#/circle/getPartnerMemberAsAdmin) to find member.
         * @summary Returns Partners config as admin by uniq code
         * @param {string} uniqCode Partner Unique Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnersConfigByUniqCodeAsAdmin(params, options) {
            return localVarFp
                .getPartnersConfigByUniqCodeAsAdmin(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Partner Child User Counts returns the number of distinct active users per child partner for a given parent partner. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner Child User Counts (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerChildUserCounts(params, options) {
            return localVarFp
                .v1GetPartnerChildUserCounts(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Partner User Count returns the number of distinct users for a partner within a date range. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner User Count (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
         * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerUserCount(params, options) {
            return localVarFp
                .v1GetPartnerUserCount(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Partner Users returns a paginated list of user accounts for a partner whose sponsorship_start_date falls within the given date range. Accounts are hydrated from the identity service. This endpoint is for internal admin use only.  Results are ordered by sponsorship `created_at DESC, user_id ASC` when `is_suspicious` is omitted (pagination driven by circle). When `is_suspicious` is supplied, the filter, pagination, and ordering are applied by identity over the full partner+date user_id set; ordering in that case is by account `created_at DESC, user_id ASC`.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner Users (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
         * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
         * @param {boolean} [isSuspicious] Optional filter on the &#x60;is_suspicious&#x60; flag. Omit to skip the filter; pass &#x60;true&#x60; to return only suspicious users; pass &#x60;false&#x60; to return only non-suspicious users.
         * @param {number} [limit] Max accounts to return per page. Defaults to 50, capped at 200.
         * @param {number} [offset] Number of accounts to skip. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerUsers(params, options) {
            return localVarFp
                .v1GetPartnerUsers(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Mark Partner Users Suspicious marks users for a partner whose sponsorship was created within a date range as suspicious or not suspicious. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin write permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Mark Partner Users Suspicious (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {CircleMarkPartnerUsersSuspiciousRequest} circleMarkPartnerUsersSuspiciousRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MarkPartnerUsersSuspicious(params, options) {
            return localVarFp
                .v1MarkPartnerUsersSuspicious(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.PartnerApiFactory = PartnerApiFactory;
/**
 * PartnerApi - object-oriented interface
 */
class PartnerApi extends base_1.BaseAPI {
    /**
     * URL `/v1/circles/admin/partners/{partner_id}/sponsorship/churn`
     * Triggers bulk sponsorship churn when partner relationships end. Queries active users for the specified partner and publishes churn events to the notification service.  Sponsorship status updates, if any, are handled asynchronously by downstream consumers of these churn events; this endpoint itself does not directly modify user sponsorship status.  For now this endpoint is intended to be used by admins to notify Iterable of sponsorship churn, but in the future it can be extended to support internal use cases.  **Admin Access Required**: This endpoint requires admin write permissions.
     * @summary Trigger bulk sponsorship churn for partner
     * @param {string} partnerId The ID of the partner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminChurnSponsorships(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .adminChurnSponsorships(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/codes/{uniq_code}/config`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Returns Partners config by partner id
     * @param {string} uniqCode Partner Unique Code
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBrandingPartnerConfig(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .getBrandingPartnerConfig(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/configs/unsponsored`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Get unsponsored config
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCircleUnsponsoredConfig(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .getCircleUnsponsoredConfig(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/dependent-groups/countries/{country_code}/config`
     *
     * @summary Returns Partner Dependent Group config by partner id and dependent group ID
     * @param {string} partnerId The ID of the partner
     * @param {string} countryCode The country code of the dependent group
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPartnerDependentGroupConfigByCountryCode(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .getPartnerDependentGroupConfigByCountryCode(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/members/search`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - | This endpoint will return the partner member for the given partner id and search criteria. This endpoint is only accessible to admin users. Note that every partner has a different set of search criteria.  Search criteria can be by: - validation fields like partnerId + (email, firstName, lastName, dob, subscriberId). - partner specific fields like partnerId + (memberId).
     * @summary Gets Partners Member as admin by partner id and search criteria.
     * @param {string} partnerId The ID of the partner
     * @param {string} [memberId] Id of the member to search
     * @param {string} [email] Email of the member to search
     * @param {string} [firstName] First name of the member to search
     * @param {string} [lastName] Last name of the member to search
     * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
     * @param {string} [subscriberId] SubscriberId of the member to search.
     * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPartnerMemberAsAdmin(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .getPartnerMemberAsAdmin(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/config`
     *
     * @summary Returns Partners config by partner id
     * @param {string} partnerId The ID of the partner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPartnersConfigById(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .getPartnersConfigById(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/codes/{uniq_code}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  This endpoint will return the partner config for the given uniq code. This endpoint is only accessible to admin users. After you got the partner config, you can use the partner_id to call the other endpoints. E.g. [/v1/partners/{partner_id}/members/search](https://apidoc.evexiaapp.site/#/circle/getPartnerMemberAsAdmin) to find member.
     * @summary Returns Partners config as admin by uniq code
     * @param {string} uniqCode Partner Unique Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPartnersConfigByUniqCodeAsAdmin(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .getPartnersConfigByUniqCodeAsAdmin(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/children/users/count`
     * v1 Get Partner Child User Counts returns the number of distinct active users per child partner for a given parent partner. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Get Partner Child User Counts (Admin Only)
     * @param {string} partnerId The ID of the partner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1GetPartnerChildUserCounts(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .v1GetPartnerChildUserCounts(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/users/count`
     * v1 Get Partner User Count returns the number of distinct users for a partner within a date range. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Get Partner User Count (Admin Only)
     * @param {string} partnerId The ID of the partner
     * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
     * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1GetPartnerUserCount(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .v1GetPartnerUserCount(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/users`
     * v1 Get Partner Users returns a paginated list of user accounts for a partner whose sponsorship_start_date falls within the given date range. Accounts are hydrated from the identity service. This endpoint is for internal admin use only.  Results are ordered by sponsorship `created_at DESC, user_id ASC` when `is_suspicious` is omitted (pagination driven by circle). When `is_suspicious` is supplied, the filter, pagination, and ordering are applied by identity over the full partner+date user_id set; ordering in that case is by account `created_at DESC, user_id ASC`.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Get Partner Users (Admin Only)
     * @param {string} partnerId The ID of the partner
     * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
     * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
     * @param {boolean} [isSuspicious] Optional filter on the &#x60;is_suspicious&#x60; flag. Omit to skip the filter; pass &#x60;true&#x60; to return only suspicious users; pass &#x60;false&#x60; to return only non-suspicious users.
     * @param {number} [limit] Max accounts to return per page. Defaults to 50, capped at 200.
     * @param {number} [offset] Number of accounts to skip. Defaults to 0.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1GetPartnerUsers(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .v1GetPartnerUsers(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/users/suspicious`
     * v1 Mark Partner Users Suspicious marks users for a partner whose sponsorship was created within a date range as suspicious or not suspicious. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin write permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Mark Partner Users Suspicious (Admin Only)
     * @param {string} partnerId The ID of the partner
     * @param {CircleMarkPartnerUsersSuspiciousRequest} circleMarkPartnerUsersSuspiciousRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1MarkPartnerUsersSuspicious(params, options) {
        return (0, exports.PartnerApiFp)(this.configuration)
            .v1MarkPartnerUsersSuspicious(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.PartnerApi = PartnerApi;
//# sourceMappingURL=partner-api.js.map